import { useTranslation } from 'react-i18next';
import { AppData } from '~/settings/service/CommonService';
import { AutoReplyExternal } from './external';
import { AutoReplyInternal } from './internal';

export function AutoReply() {
  const { t } = useTranslation();
  const supportExternalRoom = AppData.DomainConfig.supportExternalRoom;
  const isGov = window.process.TARGET === 'gov';

  return (
    <div className="settings_cover">
      <h3 className="title">
        <span className="text">{t('talk_main_replytitle_all')}</span>
      </h3>
      <ul className="settings_list">
        <AutoReplyInternal />
        {supportExternalRoom && !isGov && <AutoReplyExternal />}
      </ul>
    </div>
  );
}
